import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_201: DocMigration = {
  maxSchemaVersion: "0.0.201",
  description: "Update window mullion grid count settings",
  apply(json: any) {
    const renameMullionSettings = (setting) => {
      if (!setting) {
        return;
      }
      if (setting?.topVerticalCount !== undefined) {
        setting.paneOneXCount = setting.topVerticalCount;
        delete setting.topVerticalCount;
      }
      if (setting?.topHorizontalCount !== undefined) {
        setting.paneOneYCount = setting.topHorizontalCount;
        delete setting.topHorizontalCount;
      }
      if (setting?.lowVerticalCount !== undefined) {
        setting.paneTwoXCount = setting.lowVerticalCount;
        delete setting.lowVerticalCount;
      }
      if (setting?.lowHorizontalCount !== undefined) {
        setting.paneTwoYCount = setting.lowHorizontalCount;
        delete setting.lowHorizontalCount;
      }
      if (setting?.mullionType === "ORTHOGONAL") {
        setting.isLegacyWindowGrid = true;
      }
    };

    let globalSettingExists = false;

    // update settings
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WINDOW_MULLION_SETTINGS") {
        renameMullionSettings(setting);
        if (!setting?.mullionType) {
          setting.isLegacyWindowGrid = true;
        }
        globalSettingExists = true;
      }
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const windowTypeId in setting.windowTypes) {
          const windowType = setting.windowTypes[windowTypeId];
          if (windowType) {
            renameMullionSettings(windowType.mullions);
          }
        }
      }
    }

    // update instances
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      if (opening) {
        renameMullionSettings(opening.mullions);
      }
    }

    for (const openingId in json.gableOpenings) {
      const opening = json.gableOpenings[openingId];
      if (opening) {
        renameMullionSettings(opening.mullions);
      }
    }

    for (const openingId in json.dormers) {
      const opening = json.dormers[openingId];
      if (opening) {
        renameMullionSettings(opening.mullions);
      }
    }

    // add window mullion settings if none exist in any settings sets
    // to flag any inherited default settings as legacy
    if (!globalSettingExists) {
      const windowMullionSettingsSetId = uid();
      if (!json.settingsSets) {
        (json.settingsSets as any) = {};
      }

      (json.settingsSets[windowMullionSettingsSetId] as any) = {
        entityType: "SETTINGS_SET",
        name: "Window Mullion Settings Set",
        id: windowMullionSettingsSetId,
        sortIndex: 0,
      };

      // add Window Mullion Settings
      const newSettingsId = uid();
      (json.settings[newSettingsId] as any) = {
        ...{
          type: "WINDOW_MULLION_SETTINGS",
          isLegacyWindowGrid: true,
        },
        entityType: "SETTINGS",
        id: newSettingsId,
        parentId: windowMullionSettingsSetId,
        sortIndex: 0,
      };
    }

    return json;
  },
};

export default migration_0_0_201;
